import { Moment } from "moment";
import { apiGet, apiPost, apiPut, API_URI, CRM_API_URI, KEYWORDS_API_URI } from "./index";

const project = {
  get: async (id: number) => {
    const data = await apiGet(`${API_URI}/api/project/get?projectId=${id}`);
    return data;
  },
  getAll: async (clientId: number) => {
    const data = await apiGet(`${API_URI}/api/project/getall?clientId=${clientId}`);
    return data;
  },
  mentions: {
    get: async (projectId: number, startDate: Moment, endDate: Moment, streamIds: string) => {
      const data = await apiGet(`${API_URI}/api/mentions/getall?projectId=${projectId}&startDate=${startDate.format("DD MMM YYYY")}&endDate=${endDate.format("DD MMM YYYY")}&streamIds=${streamIds}`);
      return data;
    },
    getAll: async (clientId: number) => {
      const data = await apiGet(`${API_URI}/api/project/getall?clientId=${clientId}`);
      return data;
    },
  },
  getProjectTypes: async (parentId: number) => {
    const data = await apiPost(`${CRM_API_URI}/api/productlist/populate/full?currencyId=ZAR&parent=${parentId}`);
    return data;
  },
  getHeaderProductList: async () => {
    const data = await apiPost(`${CRM_API_URI}/api/productlist/headers/populate`);
    return data;
  },
  updateProjectName: async (binId: number, projectName: string) => {
    const data = await apiPut(`${KEYWORDS_API_URI}/api/bins/updatename?binId=${binId}&binName=${projectName}`);
    return data;
  },
  deleteProject: async (binId: number, clientId: number) => {
    const data = await apiPut(`${KEYWORDS_API_URI}/api/bins/isdeleted?id=${binId}&isDeleted=true&clientId=${clientId}`);
    return data;
  },
};

export default project;
